export default {"src":"/_next/static/media/asset-management-company.2f29cee7.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};